const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginTop: '-1px',
        position: 'relative',
        paddingLeft: '10rem',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1350)]: {
            paddingLeft: '3rem',
            paddingRight: '1rem',
            justifyContent: 'space-between'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {

        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
            flexDirection: 'column',
            padding: '0 1rem',
            paddingTop: '0',
            paddingBottom: '80px'
        }
    },
    imgWrap: {
        flexBasis: 'auto',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginTop: '-2.5rem',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
            transform: 'scale(0.8)',
            marginTop: '0'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
            order: 1,
            marginTop: '30px',
            marginBottom: '20px',
            transform: 'scale(1)',
        }
    },
    textWrap: {
        flexBasis: '50%',
        width: '100%',
        paddingLeft: '50px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
            paddingLeft: 0,
            paddingRight: '2rem'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
            order: 0
        }
    },
    img: {
        marginBottom: '-4px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1250)]: {
            width: '100%'
        }
    },
    h1: {
        fontFamily: 'Montserrat',
        fontSize: '36px',
        lineHeight: '43.2px',
        letterSpacing: '0.01em',
        color: 'black',
        display: 'table',
        maxWidth: '20ch',
        margin: 0,
        fontWeight: '700',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
            maxWidth: '100%'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 900)]: {
            fontSize: '24px',
            lineHeight: '29px'
        }
    },
    p: {
        fontFamily: 'Aktiv Grotesk',
        color: 'black',
        fontSize: '1rem',
        fontWeight: '400',
        lineHeight: '22.5px',
        letterSpacing: '0.01em',
        display: 'table',
        margin: 0,
        marginTop: '20px',
        maxWidth: '50ch',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
            maxWidth: '100%'
        }
    }
})

export default styles